import Util from "../../libs/util/Util";
import ThingsManagerClass from "../../libs/base/ThingsManagerClass";
import gsap from "gsap";

/**
 * 検索枠で使用されるモーダルの基礎クラス
 */
export default class PickModalClass extends ThingsManagerClass{
    constructor(_id,_parent){
        super();
        this.name = "PickModalClass";

        this.CL_MODAL_OPEN = "isModalOpen";

        this.EVENT_BEFORE_EVENT_CLOSE = "eventBeforeEventClose";
        this.EVENT_BEFORE_NEGATIVE = "eventBeforeNegative";
        this.EVENT_BEFORE_POSITIVE = "eventBeforePositive";

        this.EVENT_CLOSE ="eventClose";
        this.EVENT_NEGATIVE = "eventNegative";
        this.EVENT_POSITIVE = "eventPositive";

        this.id = _id;
        this.parent = _parent;

        this.onClickModalToggleListener = this.onClickModalToggle.bind(this);

        this.isOpen = false;

        this.baseHorizontal = true;//左寄り

        this.isAnimation = false;
        this.selector = null;
        this.isCloseBlock = false;

        this.isWidget = true;
    }

    onCreate() {
        super.onCreate();

        this.selector = '.js-pick_modal[data-target='+this.id+'],.pick_modal[data-id='+this.id+']';

        this.clickTarget = $('.js-pick_modal[data-target='+this.id+']',this.parent);
        this.modal = $('.pick_modal[data-id='+this.id+']',this.parent);
        //console.log(this.id,this.name,this.modal,this.clickTarget);

        this.baseHorizontal = !(this.modal.attr("data-base_position_h") === "right");

        this.clickTarget.on("click",this.onClickModalToggleListener);

        $(document).on('click', (e)=>{
            if(this.isWidget){
                if ((!(e.target.tagName === "LTIKE-WIDGET-PH") && !this.isCloseBlock) && this.isOpen) {
                    this.onClose(this.EVENT_CLOSE);
                }
                if(this.isOpen && this.isCloseBlock) {
                    this.isCloseBlock = false;
                }
            } else {
                if (!$(e.target).closest(this.selector).length && this.isOpen) {
                    this.onClose(this.EVENT_CLOSE);
                }
            }
        });

        $(this.parent).on('click', (e)=>{
            //if(this.isOpen) console.log(this.name,"isCloseBlock check:",this.isCloseBlock);
            if ((!$(e.target).closest(this.selector).length && !this.isCloseBlock) && this.isOpen) {
                this.onClose(this.EVENT_CLOSE);
            }
            if(this.isOpen && this.isCloseBlock) {
                this.isCloseBlock = false;
            }
        });

        $(".positive",this.modal).on("click",(e)=>{
            e.preventDefault();
            this.onClose(this.EVENT_POSITIVE);
        });

        $(".negative",this.modal).on("click",(e)=>{
            e.preventDefault();
            this.onClose(this.EVENT_NEGATIVE);
        });

        $(".header .close",this.modal).on("click",(e)=>{
            e.preventDefault();
            this.onClose(this.EVENT_CLOSE);
        });
    }

    onResize(_size) {
        super.onResize(_size);

        if(Util.isBreakpoint) return;

        let offset = this.clickTarget.not(":hidden").offset();
        const parent = $(this.parent);
        const parentOffset = parent.offset();
        //console.log("--0",this.name,offset);
        let position;
        if(!offset) {
            let top = (_size.h - this.modal.height()) / 2;
            let left = (_size.w - this.modal.width()) / 2;
            //console.log("--1_1",this.name,"onResize",left);
            //console.log("--1_2",this.modal.width(),this.modal.height());
            top += Util.getScrollY();
            position = {top:top,left:left};
        } else {
            //console.log("--2_1",this.name,"onResize",offset.left,this.modal.width(),$(this.parent).offset());

            const top = offset.top - parentOffset.top;
            let left = offset.left - parentOffset.left;
            let mleft = parseFloat(this.modal.css("margin-left"))*-1;
            let diff = left - mleft;
            if(diff < 0){
                left -= diff - 40;
            }
            //console.log("--2_2",left,mleft,diff);
            position = {top:top,left:left};
        }
        if(!this.baseHorizontal){
            //右寄り
            position.left = "auto";
            position.right = parent.width() - (offset.left - parentOffset.left + this.clickTarget.outerWidth(true));
        }
        //console.log("--",position);
        this.modal.css(position);
    }

    onChangeBreakPoint(b) {
        super.onChangeBreakPoint(b);

        if(Util.isBreakpoint){
            this.modal.css({top:"",left:""});
            if(this.isOpen) {
                $("html").css({overflow:"hidden"});
            }
        } else {
            gsap.set(this.modal,{y:""});
            if(this.isOpen) {
                $("html").css({overflow:""});
            }
        }
    }

    onClickModalToggle(e){
        e.preventDefault();

        //console.log("onClickModalToggle",this.isOpen);

        if(this.isOpen){
            this.onClose(this.EVENT_CLOSE);
        } else {
            this.onOpen();
        }
    }

    onClose(_event){
        if(this.isAnimation || !this.isOpen) return;
        //console.log("onClose",this.isOpen);
        this.isOpen = false;

        switch (_event){
            case this.EVENT_NEGATIVE:
                this.onNegativeBefore();
                this.jq.trigger(this.EVENT_BEFORE_NEGATIVE);
                break;
            case this.EVENT_POSITIVE:
                this.onPositiveBefore();
                this.jq.trigger(this.EVENT_BEFORE_POSITIVE);
                break;
            case this.EVENT_CLOSE:
                this.onEventCloseBefore();
                this.jq.trigger(this.EVENT_BEFORE_EVENT_CLOSE);
                break;
        }

        $("html").removeClass(this.CL_MODAL_OPEN);
        Util.isSpModalOpen = false;
        if(Util.isBreakpoint) {
            $('html,body').scrollTop(this.scrollTop);
            $("html").css({overflow:""});
        }

        this.onCloseBefore();

        const time = 0.3;
        const ease = "power2.out";
        gsap.killTweensOf(this.modal);
        let y = 0;
        if(Util.isBreakpoint) y = "100%";
        //console.log(this.name,"onClose before");
        gsap.to(this.modal,{duration:time,opacity:0,y:y,ease:ease,onComplete:()=>{
                this.modal.css({display:""}).scrollTop(0);

                switch (_event){
                    case this.EVENT_NEGATIVE:
                        this.onNegative();
                        break;
                    case this.EVENT_POSITIVE:
                        this.onPositive();
                        break;
                    case this.EVENT_CLOSE:
                        this.onEventClose();
                        break;
                }

                if(_event) this.jq.trigger(_event);
                //console.log(this.name,"onClose after",_event);

                this.isAnimation = false;
                this.onCloseAfter();
            }
        });
    }

    onCloseBefore(){}
    onCloseAfter(){}

    onOpen(){
        if(this.isAnimation || this.isOpen) return;
        //console.log(this.name,"onOpen",this.modal,this.isOpen);
        this.scrollTop = Util.getScrollY();
        this.isOpen = true;
        const time = 0.3;
        const ease = "power2.out";
        gsap.killTweensOf(this.modal);

        this.modal.css({display:"block"});
        $(window).trigger("resize");
        if(Util.isBreakpoint) {
            $("html").css({overflow:"hidden"});
            gsap.set(this.modal,{y:"100%"});
        }
        this.onOpenBefore();
        //console.log("open before",this.isOpen);
        gsap.to(this.modal,{duration:time,opacity:1,y:"0%",ease:ease,onComplete:()=>{
                this.isAnimation = false;
                $("html").addClass(this.CL_MODAL_OPEN);
                Util.isSpModalOpen = true;
                this.modal.css({transform:""});
                if(Util.isBreakpoint) {
                    $('html,body').scrollTop(this.scrollTop);
                    $(window).trigger("resize");
                }
                this.onOpenAfter();
                //console.log("open after");
            }
        });
    }

    onOpenBefore(){}
    onOpenAfter(){}

    onSetClickTargetText(_text){
        $(".text",this.clickTarget).text(_text);
    }

    onPositive(){}
    onPositiveBefore(){}
    onNegative(){}
    onNegativeBefore(){}

    onEventClose(){}
    onEventCloseBefore(){}
}